var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7303 13.996C15.2673 15.403 13.4533 16.105 12.1573 15.988C10.3873 15.828 8.4613 14.889 6.9993 13.855C4.8503 12.335 2.8373 9.98396 1.6643 7.48896C0.835297 5.72596 0.649297 3.55796 1.8823 1.95096C2.3383 1.35696 2.8313 1.03996 3.5723 1.00296C4.6003 0.952958 4.7443 1.54096 5.0973 2.45696C5.3603 3.14196 5.7113 3.84096 5.9073 4.55096C6.2743 5.87596 4.9913 5.93096 4.8293 7.01396C4.7283 7.69696 5.5563 8.61296 5.9303 9.09996C6.6633 10.054 7.5443 10.877 8.5383 11.503C9.1073 11.862 10.0263 12.509 10.6783 12.152C11.6823 11.602 11.5873 9.90896 12.9913 10.482C13.7183 10.778 14.4223 11.205 15.1163 11.579C16.1893 12.156 16.1393 12.754 15.7303 13.996C15.4243 14.924 16.0363 13.068 15.7303 13.996",
    stroke: "#626262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.5b2e21ea.svg";
export { ForwardRef as ReactComponent };